import React, { useState, useRef, useEffect } from "react"

import Textarea from "../../../../components/ui/inputs/textarea"
import Button from "../../../../components/ui/button/button"
import { ACTIVITY_TYPES, COMPOSER_PLACEHOLDERS } from "./types"

/**
 * Inline composer for adding a new activity entry. Renders when a quick-action
 * has been picked. Saves once, then unmounts via onSaved.
 */
export default function Composer({ type, onSave, onCancel, submitLabel = "Log entry" }) {
	const [body, setBody] = useState("")
	const [saving, setSaving] = useState(false)
	const wrapperRef = useRef(null)

	useEffect(() => {
		// Pull focus into the textarea when the composer first appears
		const ta = wrapperRef.current?.querySelector("textarea")
		ta?.focus()
	}, [])

	const handleSave = async () => {
		const trimmed = body.trim()
		if (!trimmed && type !== "NOTE") {
			// Allow logging a call/email with no body for fast capture, but
			// require a body for plain notes since otherwise there is nothing.
		}
		if (!trimmed && type === "NOTE") return

		setSaving(true)
		try {
			await onSave({ body: trimmed })
			setBody("")
		} finally {
			setSaving(false)
		}
	}

	const onKeyDown = (e) => {
		if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
			e.preventDefault()
			handleSave()
		}
		if (e.key === "Escape" && onCancel) {
			e.preventDefault()
			onCancel()
		}
	}

	const meta = ACTIVITY_TYPES[type]

	return (
		<div className="enquiry-composer" ref={wrapperRef}>
			<div className="enquiry-composer-header">
				<span className="enquiry-composer-type">{meta?.label || "Activity"}</span>
				<small className="enquiry-composer-hint">
					<kbd>⌘</kbd>
					<kbd>Enter</kbd>
					to save
				</small>
			</div>

			<div onKeyDown={onKeyDown}>
				<Textarea
					value={body}
					onChange={setBody}
					placeholder={COMPOSER_PLACEHOLDERS[type] || "Add a note…"}
					rows={4}
					resize={false}
				/>
			</div>

			<div className="enquiry-composer-actions">
				{onCancel && (
					<Button
						small={true}
						className="OUTLINE"
						label="Cancel"
						onClick={onCancel}
					/>
				)}
				<Button
					small={true}
					label={submitLabel}
					loading={saving}
					loadingText="Saving…"
					onClick={handleSave}
				/>
			</div>
		</div>
	)
}
